var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrack9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 44,
    viewBox: "0 0 130 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1224 3.45065L53.6566 7.46836C59.4869 8.06087 64.9599 10.5564 69.2305 14.5695L76.5173 21.4168C83.8962 28.3509 95.1954 28.9664 103.284 22.875L108.182 19.1862C115.925 13.3552 127 18.8791 127 28.5719C127 35.2682 121.412 40.6105 114.722 40.3095L36.3023 36.7806C34.86 36.7157 33.8072 35.3918 34.0688 33.9719C35.4275 26.5959 27.1551 21.2863 21.0151 25.5935L13.0304 31.1947C8.80817 34.1566 3 31.1362 3 25.9787V13.5C3 7.51748 8.17051 2.84579 14.1224 3.45065Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack9);
export default __webpack_public_path__ + "static/media/track9.571f3fff.svg";
export { ForwardRef as ReactComponent };